import { Injectable, Directive } from '@angular/core';
import { CanDeactivate } from '@angular/router';

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<ComponentCanDeactivate> {
  canDeactivate(component: ComponentCanDeactivate): boolean {
   
    if(!component.canDeactivate()){
        if (confirm("تأكيد الخروج من إضافة تقرير جديد")) {
            return true;
        } else {
            return false;
        }
    }
    return true;
  }
}

import { HostListener } from "@angular/core";

@Directive()
export abstract class ComponentCanDeactivate {
    abstract canDeactivate(): boolean;
    @HostListener('window:beforeunload', ['$event'])
    unloadNotification($event: any) {
        if (!this.canDeactivate()) {
            $event.returnValue = true;
        }
    }
}